import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { BaasLink } from '../../baas-link/baas-link';
import { BaasRemarkType } from '../baas-remark.type';
import { BaasRemarkOptions } from '../baas-remark-options.type';
import { _BAAS_REMARK_MAPPINGS } from '../remark-constants';

@Component({
    selector: 'baas-remark',
    templateUrl: './baas-remark.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, BaasLink]
})
export class BaasRemark {
    readonly remark = input<BaasRemarkOptions>();

    readonly type = input<BaasRemarkType>();

    protected readonly color = computed(() => _BAAS_REMARK_MAPPINGS[this.#type()].color);

    protected readonly icon = computed(() => _BAAS_REMARK_MAPPINGS[this.#type()].class);

    readonly #type = computed(() => {
        if (this.remark()?.type) return this.remark().type;
        return this.type();
    });
}
